import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowDownRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M8.364 17.074a1.5 1.5 0 0 1 .325-1.635l2.315-2.314L6.439 8.56a1.5 1.5 0 1 1 2.122-2.122l4.564 4.565 2.314-2.315A1.5 1.5 0 0 1 18 9.75v6.75a1.5 1.5 0 0 1-1.5 1.5H9.75a1.5 1.5 0 0 1-1.385-.925'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowDownRight)
export default ForwardRef
